import { createFileRoute } from '@tanstack/react-router';

import { ToolFrame } from '../app/tool-frame.js';
import { PondBatSection } from '../features/projects/detail/pond-bat/pond-bat-section.js';

export const Route = createFileRoute(
  '/_authed/teams/$teamId/projects/$projectId/pond-bat-checker',
)({
  component: () => (
    <ToolFrame toolSlug="pond-bat-checker" Section={PondBatSection} requiresReport />
  ),
});
